import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GearboxDataInput } from '../models';

export interface GearboxState {
    n2Error: boolean;
    gearboxInertiaError: boolean;
    loadInertiaError: boolean;
    renderGearboxInertiaDialog: boolean;
    gearboxInputData: GearboxDataInput;
}

const initialState: GearboxState = {
    n2Error: false,
    gearboxInertiaError: false,
    loadInertiaError: false,
    renderGearboxInertiaDialog: false,
    gearboxInputData: {
        n2: '',
        gearboxInertia: '',
        loadInertia: ''
    }
};

export const GearboxSlice = createSlice({
    name: 'gearbox',
    initialState,
    reducers: {
        setGearboxInputData: (state: GearboxState, action: PayloadAction<Partial<GearboxDataInput>>) => {
            state.gearboxInputData = { ...state.gearboxInputData, ...action.payload };
        },
        setGearboxInertiaDialog: (state: GearboxState, action: PayloadAction<boolean>) => {
            state.renderGearboxInertiaDialog = action.payload;
        },
        setN2Error: (state: GearboxState, action: PayloadAction<boolean>) => {
            state.n2Error = action.payload;
        },
        setGearboxInertiaError: (state: GearboxState, action: PayloadAction<boolean>) => {
            state.gearboxInertiaError = action.payload;
        },
        setLoadInertiaError: (state: GearboxState, action: PayloadAction<boolean>) => {
            state.loadInertiaError = action.payload;
        }
    }
});

export const {
    setGearboxInputData,
    setGearboxInertiaDialog,
    setN2Error,
    setGearboxInertiaError,
    setLoadInertiaError
} = GearboxSlice.actions;
export const gearboxReducer = GearboxSlice.reducer;
